import SideBarHeading from "./SideBarHeading";

export { SideBarHeading };
